import UpdateCart from './Components/UpdateCart';
import QuantitySwitcher from './Components/quanityChange';

let quantitySwitchers = [];

document.addEventListener('DOMContentLoaded', () => {
    initUpdateCart();
    initQuantitySwichers();
});

const initUpdateCart = async () => {
    new UpdateCart();
};

const initQuantitySwichers = async () => {
    try {
        const buttons = await areButtonsExists();
        await deleteClassInstance();
        buttons.forEach((button) => {
            const quantitySwitcher = new QuantitySwitcher(button, true);
            quantitySwitchers.push(quantitySwitcher);
        });
    } catch (error) {
        return;
    }
};

const deleteClassInstance = () => {
    return new Promise((resolve) => {
        if (quantitySwitchers.length < 1) resolve();

        quantitySwitchers.forEach((switcher) => {
            switcher = null;
        });

        quantitySwitchers = [];
    });
};

const areButtonsExists = () => {
    return new Promise((resolve, reject) => {
        const buttons = document.querySelectorAll('.quantity');
        buttons.length >= 1 ? resolve(buttons) : reject();
    });
};

jQuery(document).on('ajaxComplete', (e) => {
    initQuantitySwichers();
});

jQuery('body.woocommerce-cart').on('click', '.wc-proceed-to-checkout', function (event) {
    if (jQuery('.woocommerce-error').length > 0) {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });

        event.preventDefault();
    }
});
